import React, { useEffect } from "react"
import { useState } from "react"
import styled from "styled-components"
import FormInput from "../components/FormInput"
import { ToastContainer, toast } from "react-toastify"
// import { app } from "../firebase-config"
import { getAuth, signInWithEmailAndPassword } from "firebase/auth"
import "react-toastify/dist/ReactToastify.css"
import { Link, useNavigate } from "react-router-dom"
import { addDoc, doc, setDoc, updateDoc } from "firebase/firestore"
import { db } from "../firebase-config"



const LoginScreen = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()


 
  const handleLogin = async (e) => {
    e.preventDefault()
    const authentication = getAuth()

    if (email && password) {
      try {
        setLoading(true)
        const resp = await signInWithEmailAndPassword(
          authentication,
          email,
          password
        )
        console.log(resp)
        if(authentication.currentUser.emailVerified){
          setLoading(true)
          const personalInfo = {
            name: resp.user.displayName,
            email: email,
          }
          setDoc(doc(db, "users", resp.user.uid), {
            personalInfo,
            uid: resp.user.uid,
            isOnline: true,
          }, {merge: true})
          localStorage.setItem("Auth Token", resp._tokenResponse.refreshToken)
          toast.success("Logged in")
          setLoading(false)
          setTimeout(() => {
            navigate("/")
          }, 1000)
        }else {
          setLoading(false)
          toast.error("Please Verify Email")
        }
      } catch (error) {
        setLoading(false)
        console.log(error)
        console.log(error.code)

        if (error.code === "auth/email-already-in-use") {
          toast.error("Email Already in use")
          setLoading(false)
        } else {
          setLoading(false)
          toast.error(error.code)
        }
      }
    } else {
      toast.warn("Please fill all details")
    }
  }

  useEffect(() => {
    const unsub = localStorage.getItem('Auth Token')
    if(unsub){
      navigate('/')
    }
    return () => unsub
  }, []);
  

  return (
    <LoginWrap>
      <ToastContainer position={"top-center"} autoClose={3000} limit={1} />
      <FormContainer onSubmit={handleLogin}>
        <h2>Login</h2>
        <FormInput
          type="email"
          value={email}
          isReq={true}
          handleOnChange={e => setEmail(e.target.value)}
          label={"Email Address*"}
          placeholder={"Email Address"}
        />
        <FormInput
          isReq={true}
          isPassword={true}
          value={password}
          handleOnChange={e => setPassword(e.target.value)}
          label={"Password*"}
          placeholder={"Password"}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            margin: "0.5rem 0",
            justifyContent: "space-between",
          }}
        >
          <div>
            <input type="checkbox" />
            <span>Remember me</span>
          </div>
          <BtnLink to="/reset-password">Forgot Password?</BtnLink>
        </div>
        <div>

        <GradientBtn accessKey="enter">
          {loading ? (
            
            "Authenticating.."
            ) : (
              "Login"
              )}
        </GradientBtn>
        </div>
        <BtnLink to="/signup" style={{ textAlign: "center" }}>
          Don't have account ? Create Account
        </BtnLink>
      </FormContainer>
    </LoginWrap>
  )
}

export default LoginScreen

const LoginWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80vh;
  
`

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 25%;
  max-width: 25%;
  height: 80%;
  h2 {
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    text-transform: uppercase;
  }
  @media (max-width: 768px) {
    width: 80%;
    max-width: 80%;
    height: 50%;
  }
`
const GradientBtn = styled.button`
  border: none;
  background: ${({theme}) => theme.accent};
;
  border-radius: 6px;
  width: 100%;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  height: 2.5rem;
`

const  BtnLink = styled(Link)`
    text-decoration: none;
    font-size: 1rem;
  font-weight: normal;
  cursor: pointer;
  color: ${({theme}) => theme.text};
`